<template>
  <div :class="{ 'card-fullscreen' : card_fullscreen, 'mt-0' : !card_fullscreen }">

    <b-row :class="card_fullscreen ? 'full-screen' : ''">
      <b-col>
        <b-row class="align-items-center table-materials">

          <b-col :class="rightTable ? 'col-md-4' : 'col-md-2'">
            <AppSearchInput
              :label="$t('warehouses')+':'"
              :placeholder="$t('search')"
              @callback="search"
            />
          </b-col>

          <b-col class="col-md-6 text-right ml-auto">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-warehouse
              style="margin-top: 18px"
              variant="primary"
              @click="editWarehouse = {}"
            >
              <feather-icon
                icon="PlusIcon"
                size="16"
              />
              {{$t('general.add')}}
            </b-button>
          </b-col>
          <b-col class="col-md-12">
            <b-table
              class="border"
              :fields="fields"
              :items="GET_WAREHOUSE_TABLE.results"
              show-empty
              responsive
              selectable
              :select-mode="selectMode"
              :empty-text="$t('empty_text')"
              @row-clicked="onRowSelected"
            >
              <template #head()="props">
                <span>{{ $t(props.label) }}</span>
              </template>

              <template #cell(actions)="props">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-warehouse
                  size="sm"
                  class="ml-2 mt-50 mb-50"
                  variant="warning"
                  @click="editWarehouse = props.item"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="15"
                  />
                </b-button>

              </template>

              <template #cell(is_active)="props">
                <b-button
                  size="sm"
                  :variant="props.item.is_active ? 'success' : 'danger'"
                >
                  {{ props.item.is_active ? $t('active') : $t('not_active') }}
                </b-button>
              </template>
            </b-table>
            
            <Pagination
              class="mt-2"
              :nobody="nobody"
              :rows="GET_WAREHOUSE_TABLE.count"
              :params="params"
              @refresh="refresh()"
            />
          </b-col>

        </b-row>
      </b-col>

      <b-col v-show="rightTable">
        <pinUsers
          :object="object"
        />
      </b-col>
    </b-row>

    <addWarehouse
      :object="object"
      :edit-warehouse="editWarehouse"
      @save="refresh"
    />
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BRow,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import pinUsers from '@/views/modules/Reference/warehouse/pinUsers.vue'
import Pagination from '@/components/Pagination.vue'
import addWarehouse from './modals/addWarehouse.vue'

export default {
  components: {
    BButton,
    BCol,
    BRow,
    BTable,
    pinUsers,
    AppSearchInput,
    Pagination,
    addWarehouse,
  },
  directives: {
    Ripple,
  },
  data() {
    return {





      // ===============  PRIMARY_DATA_SECTION START ===============
      rightTable: false,
      object: null,
      editWarehouse: {},
      nobody: true,
      selectMode: 'single',
      params: {
        search: null,
        page_size: 10,
        page: 1,
      },
      card_fullscreen: false,
      // ===============  PRIMARY_DATA_SECTION END ===============










      // ===============  SECONDARY_DATA_SECTION START ===============
      fields: [
        {
          label: 'id',
          key: 'id',
        },
        {
          label: 'namee',
          key: 'title',
        },
        {
          label: 'status',
          key: 'is_active',
        },
        {
          label: 'actions',
          key: 'actions',
        },
      ],
      // ===============  SECONDARY_DATA_SECTION END ===============





    }
  },
  computed: {
    ...mapGetters('obectsWarehouse', ['GET_WAREHOUSE', 'GET_WAREHOUSE_TABLE']),
  },
  async mounted() {


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh()
    // ===============  PRIMARY_REQUESTS_SECTION END ===============


  },
  methods: {
    ...mapActions('obectsWarehouse', ['FETCH_WAREHOUSE_TABLE', 'FETCH_WAREHOUSE_LEFT_TABLE']),




    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      await this.FETCH_WAREHOUSE_TABLE({ is_object: true, ...this.params })
    },
    // ===============  REFRESH_SECTION END ===============






    // ===============  FILTER_SECTION START ===============
    async onRowSelected(item) {
      this.object = item.object

      if(item.object == null){
        this.$_errToast({message: this.$t('the_warehouse_is_not_attached_to_the_object')});
      }

      try {
        await this.FETCH_WAREHOUSE_LEFT_TABLE({
          object: item.object.id,
          is_object: 0,
        }).then(() => {})
        .catch((error) => {
          
        })
        this.rightTable = true
      } catch (error) {
        
      }

    },

    async search(text) {
      this.params.search = text
      await this.refresh()
    },
    // ===============  FILTER_SECTION END ===============











  },
}
</script>

<style>
.card-fullscreen {
  display: block;
  z-index: 1032;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 40px;
  background-color: #F8F8F8;
}

.full-screen {
  padding: 27px 7px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
}

.table-materials .table.b-table > tbody > .table-active, [dir] .table.b-table > tbody > .table-active > th, [dir] .table.b-table > tbody > .table-active > td {
  color: #fff;
  background-color: #5a9cd9 !important;
}
</style>
